import React from "react";

import Layout from "../components/layout";
import SEO from "../components/seo";

import GenericImage from "../components/generic-image";

import NetworkInsightsLogo from "../images/network-insights/network-insights-logo.svg";

const IndexPage = () => (
  <Layout>
    <SEO title="Network Insights Case Study" />
    <div className="container-fluid page case-study footprints-case-study">
      <div className="container">
        <section className="heading p-0" style={{position: "relative"}}>
          <GenericImage filename="network-insights/network-insights-cover.png" />
          <img src={NetworkInsightsLogo} alt="Network Insights Logo" style={{
            position: "absolute",
            top: "25%",
            left: 0,
            right: 0,
            margin: "0 auto"
          }}/>
        </section>
        <section>
          <div className="row">
            <div className="col-md-4">
              <h3>Objective</h3>
            </div>
            <div className="col-md-8 mb-5">
              <p>To create a platform for addressing cellular network quality issues faced by users. To allow network operators to identify and mitigate issues and reduce subscriber churn.</p>
            </div>
            <div className="col-md-4">
              <h3>Problem Statement</h3>
            </div>
            <div className="col-md-8 mb-5">
              <ul>
                <li>Cellular networks overloaded and increasingly unreliable</li>
                <li>Quality of user experience is largely subjective and lacks a precise metric</li>
                <li>Difficult to compare quality of experience provided by different operators due to lack of an objective metric</li>
                <li>Operators engaging in price wars and not motivated enough to compete on quality</li>
              </ul>
            </div>
          </div>
        </section>
        <section className="mt-4" style={{
              backgroundImage: "linear-gradient(to bottom, #5775d0, #683ab9)",
            }}>
          <div className="row text-white">
            <div className="col-md-4">
              <h3 className="text-white">Solution</h3>
            </div>
            <div className="col-md-8">
              <ul>
                <li className="text-white">Give the end users complete transparency into their quality of experience</li>
                <li className="text-white">Give them a precise metric using which they can quantify their quality of experience</li>
                <li className="text-white">Enable users to pick the best operator based on their patterns of movement and usage</li>
                <li className="text-white">Enable operators to compete on quality to retain their customers and to acquire new customers</li>
                <li className="text-white">Provide regulatory authorities (Eg: TRAI in India) with unbiased reports on the quality of experience provided by different operators</li>
              </ul>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="col-md-4">
              <h3>Key Features</h3>
            </div>
            <div className="col-md-8">
              <ul>
                <li>Dashboards for users, communities and operators giving them key insights into network performance enabling them with information to pick the best operator, and for operators to retain users and acquire new customers</li>
                <li>Customer engagement tool for operators where they can track, segment and engage with customers with intent to retain their highest ARPU consumers and to acquire new customers who are prime targets based on data</li>
              </ul>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-md-4 phone-proto">
              <GenericImage filename="network-insights/widget-1.jpg" />
            </div>
            <div className="col-md-4 phone-proto">
              <GenericImage filename="network-insights/widget-2.jpg" />
            </div>
            <div className="col-md-4 phone-proto">
              <GenericImage filename="network-insights/widget-3.jpg" />
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-md-4">
              <GenericImage filename="network-insights/widget-4.jpg" />
            </div>
            <div className="col-md-8">
              <h3>AI Enabled Solution</h3>
              <p>Our product includes deep learning models that automatically score voice call quality, record call drops and data speeds experienced by the end users.</p>
              <p>With the data we gather we will establish a ‘Baseline’ model of user movement patterns, signal quality, typical data speeds voice quality etc through the day. We will build anomaly detection algorithms that detect whenever the observed pattern is off the baseline pattern by a threshold. This can be used as an early warning system for extraordinary events such as terrorist attacks, natural calamities, signal jamming attacks etc</p>
            </div>
          </div>
        </section>
        <section className="mt-4">
          <h3 className="mb-5">Website Design</h3>
          <GenericImage filename="network-insights/website-desktop-and-phone.png" />
          <p className="text-center mt-3 mb-5">Landing page - Mobile Web and Desktop</p>
          <GenericImage filename="network-insights/website-for-users.png" />
          <p className="text-center mt-3 mb-5">Problem indication for Users</p>
          <div className="row">
            <div className="col-md-6">
              <GenericImage filename="network-insights/website-for-community.png" />
              <p className="text-center mt-3 mb-5">Problem indication for Community</p>
            </div>
            <div className="col-md-6">
              <GenericImage filename="network-insights/website-for-providers.png" />
              <p className="text-center mt-3 mb-5">Problem indication for Providers</p>
            </div>
          </div>
          <h4 className="mb-3">Summary and Detailed Network Performance Dashboards</h4>
          <GenericImage filename="network-insights/website-reports.png" />
          <p className="mt-3 mb-5">Get summary report cards that compares your operator's performance against other operators in the same area.</p>
          <GenericImage filename="network-insights/website-map-reports.png" />
          <p className="mt-3 mb-5">Explore your activity in detail with location based highlight of network problems.</p>
        </section>
      </div>
    </div>
  </Layout>
)

export default IndexPage
